import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class InventoryItem extends ApiService {
  template = "defaultTemplate";
  namespace = "inventory-item";
  relations = "?expand=prices,prices.vendor";
  icon = "PalletizedBoxes";
  action = "action";
  favicon = "BoxWithLabel";
  name = "Inventory";
  action_lable = this.t("Inactivate");
  singular = this.terminology.inventoryItem.singular;
  plural = this.terminology.inventoryItem.plural;
  vowel = this.terminology.inventoryItem.vowel;
  Width = 1200;
  DOMAIN = DOMAIN.INVENTORY_ITEMS;
  search = true;
  gemItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: "All Inventory Items Receivings",
      icon: AppIcons.LIST,
      services: -48,
    },
    {
      key: "create",
      label: "Inventory Item Receiving",
      icon: AppIcons.BRIEFCASE2,
      services: -48,
    },
    {
      key: "create",
      label: "Add a Non-Inventory Item Receiving",
      icon: AppIcons.PLUS,
      services: -54,
    },
    {
      key: "create",
      label: "Add a Service Receiving",
      icon: AppIcons.PLUS,
      services: -52,
    },
    {
      key: "create",
      label: "Adjust Inventory",
      icon: AppIcons.BRIEFCASE2,
      services: -53,
    },

    {
      key: "create",
      label: "Add Warehouses",
      icon: AppIcons.PLUS,
      services: -49,
    },
    {
      key: "listing",
      label: "All Warehouses",
      icon: AppIcons.LIST,
      services: -49,
    },
    {
      key: "create",
      label: "Add Warehouse Location",
      icon: AppIcons.PLUS,
      services: -47,
    },
    {
      key: "listing",
      label: "All Warehouse Locations",
      icon: AppIcons.LIST,
      services: -47,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.GEAR,
      field: "display_name",
    },
    {
      header: "Number",
      icon: AppIcons.SHRED,
      field: "number",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Inventory Item...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Inventory",
      icon: AppIcons.LIST,
    },
  ];
  constructor() {
    super("in-items");
  }
}
